<div class="card p-6">
    <div class="card p-6">
        <div class="font-semibold text-xl mb-1">Préférences de notifications</div>
        <span class="text-gray-600 text-sm">
            Sélectionnez les notifications que vous souhaitez recevoir par e-mail.
            Note : vous continuerez à recevoir les messages importants de service (paiement, sécurité,
            légaux).
        </span>
        s
        <div class="space-y-8 mt-8 w-3/4 mx-auto">

            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <div
                        class="w-12 h-12 flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-full mr-4">
                        <i class="pi pi-envelope text-blue-500 text-xl"></i>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-semibold">Newsletter</span>
                        <span class="text-gray-500 text-xs">Recevez nos dernières actualités et
                            analyses</span>
                    </div>
                </div>
                <p-toggleswitch [(ngModel)]="newsletterChecked" />
            </div>

            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <div
                        class="w-12 h-12 flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-full mr-4">
                        <i class="pi pi-bolt text-green-500 text-xl"></i>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-semibold">Nouveaux pronostics</span>
                        <span class="text-gray-500 text-xs">Soyez alerté dès qu'une nouvelle probabilité
                            est disponible</span>
                    </div>
                </div>
                <p-toggleswitch [(ngModel)]="newPredictionChecked" />
            </div>
            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <div
                        class="w-12 h-12 flex items-center justify-center bg-yellow-100 dark:bg-yellow-400/10 rounded-full mr-4">
                        <i class="pi pi-bell text-yellow-500 text-xl"></i>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-semibold">Résultats de vos suivis</span>
                        <span class="text-gray-500 text-xs">Recevez un résumé des résultats de vos
                            prédictions suivies</span>
                    </div>
                </div>
                <p-toggleswitch [(ngModel)]="resultsNotificationChecked" />
            </div>

            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <div
                        class="w-12 h-12 flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-full mr-4">
                        <i class="pi pi-gift text-purple-500 text-xl"></i>
                    </div>
                    <div class="flex flex-col">
                        <span class="font-semibold">Offres spéciales</span>
                        <span class="text-gray-500 text-xs">Soyez informé des offres et promotions
                            exclusives</span>
                    </div>
                </div>
                <p-toggleswitch [(ngModel)]="promoChecked" />
            </div>

        </div>
    </div>

</div>